var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-center my-5" }, [
    _c(
      "h4",
      { style: { color: _vm.$store.state.healthyHabits.chart.color } },
      [
        _vm._v(_vm._s(_vm.$t("calendar")) + " "),
        _c("b-icon-question-circle", {
          staticClass: "info-title",
          on: {
            click: function($event) {
              $event.preventDefault()
              _vm.$store.state.healthyHabits.showCalendarLegendModal = true
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { attrs: { id: "healthyHabitsCalendarContainer" } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1069942a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1069942a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-habits/HealthyHabitsCalendar.vue
// module id = 4194
// module chunks = 60